export default class UnidadeModel {
  id_clube: string | null;
  razao_social: string | null;

  constructor(
    id_clube: string | null,
    razao_social: string | null
  ) {
    this.id_clube = id_clube;
    this.razao_social = razao_social;
  }

  static fromApiResponse(data: any): UnidadeModel {
    return new UnidadeModel(
      data.id_clube || null,
      data.razao_social || null
    );
  }

  static fromApiResponseArray(dataArray: any[]): UnidadeModel[] {
    return dataArray.map((data) => UnidadeModel.fromApiResponse(data));
  }
}
